import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface GetPrepaymentAccountResponse {
  paymentsLeft: number;
  expiryDate: string | null;
}

export interface PaymentPackage {
  id: string;
  numberOfPayments: number;
  price: number;
  expiryDate: string;
}

export interface GetPaymentPackagesResponse {
  paymentPackages: PaymentPackage[];
}

@Injectable({ providedIn: 'root' })
export class MxpPrepaymentAccountService {
  private readonly url = environment.paymentUrl.replace(/\/$/, '') + '/api/mxp-prepayment-accounts';

  constructor(private readonly http: HttpClient) {}

  getPrepaymentAccount(): Observable<GetPrepaymentAccountResponse> {
    return this.http.get<GetPrepaymentAccountResponse>(this.url);
  }

  getPaymentPackages(): Observable<GetPaymentPackagesResponse> {
    return this.http.get<GetPaymentPackagesResponse>(this.url + '/packages');
  }

  reloadPrepayments(request: { prepaymentPackageId: string; tokenUserId: string }): Observable<void> {
    return this.http.post<void>(this.url + '/reload', request);
  }
}
